<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container" [dir]="dir"
  [ngClass]="{'minisidebar': minisidebar, 'boxed': boxed, 'danger': danger, 'blue': blue, 'green': green, 'dark': dark,  'horizontal' : horizontalActive }">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <mat-toolbar color="primary" class="topbar telative">
    <div class="w-100 fix-width-for-horizontal">
      <!-- ============================================================== -->
      <!-- Logo - style you can find in header.scss -->
      <!-- ============================================================== -->
      <div class="navbar-header">
        <a class="navbar-brand" href="/">
          <!-- BSecured Logo -->
           <img src="assets/images/bsecured-logo-white.svg" alt="BSecured" class="bsecured-navbar-logo">
        </a>
      </div>
      <!-- ============================================================== -->
      <!-- sidebar toggle (hidden only when the horizontal top-nav is actually in force) -->
      <!-- ============================================================== -->

      <button *ngIf="!horizontalActive" mat-icon-button (click)="snav.toggle() && clickEvent()" class="sidebar-toggle" value="sidebarclosed" matTooltip="Toggle Menu" aria-label="Toggle Menu">
        <mat-icon>menu</mat-icon>
      </button>
      <!-- ============================================================== -->
      <!-- Tenant Name Display -->
      <!-- ============================================================== -->
      <div class="tenant-name" style="display: flex; align-items: center; margin-left: 16px; color: white; font-size: 16px; font-weight: 500;">
        Yashwantrao Chavan Maharashtra Open University
      </div>
      <span style="flex: 1 1 auto;"></span>
      <!-- ============================================================== -->
      <!-- app header component - style you can find in header.scss / header.component.ts-->
      <!-- ============================================================== -->
      <div *ngIf="!horizontalActive else horizontalheader">
        <app-vertical-header></app-vertical-header>
      </div>

      <ng-template #horizontalheader>
        <app-horizontal-header></app-horizontal-header>
      </ng-template>

      <!-- ============================================================== -->
      <!-- Right sidebar toggle - style you can find in rightsidebar.component.scss -->
      <!-- ============================================================== -->
      <button (click)="end.toggle()" mat-icon-button class="ml-xs overflow-visible" matTooltip="Settings" aria-label="Settings">
        <mat-icon>settings</mat-icon>
      </button>
    </div>

  </mat-toolbar>
  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- Horizontal nav bar (desktop only - below the sidenav breakpoint we fall back to the drawer) -->
  <!-- Sits below the topbar, replaces the left sidenav entirely. -->
  <!-- ============================================================== -->
  <nav class="horizontal-nav" *ngIf="horizontalActive">
    <app-horizontal-sidebar></app-horizontal-sidebar>
  </nav>

  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
    [ngClass]="{'minisidebar': minisidebar && !horizontalActive}">
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- In horizontal mode the sidenav is force-closed & its content hidden. -->
    <!-- ============================================================== -->
    <mat-sidenav #snav id="snav" class="pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0"
      [opened]="!horizontalActive && mobileQuery.matches" [disableClose]="!horizontalActive && mobileQuery.matches"
      (open)="sidebarOpened = true" (close)="sidebarOpened = false">

      <div *ngIf="!horizontalActive" class="scbar" style="height: 100%; overflow-y: auto;">
        <app-vertical-sidebar class="app-sidebar"></app-vertical-sidebar>
      </div>

    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right Sidebar - style you can find in rightsidebar.component.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #end position="end" class="chat-panel" mode="over" opened="false">
      <div class="scroll">
        <div class="settings-panel">

          <h3 class="settings-heading text-uppercase font-weight-bold">Settings</h3>
          <div class="settings-row" *ngIf="!minisidebar">
            <mat-slide-toggle color="warn" [checked]="horizontal"
              (change)="toggleHorizontal($event.checked)">
              Horizontal Layout</mat-slide-toggle>
          </div>
          <div class="settings-row">
            <mat-slide-toggle color="warn" [checked]="dir === 'rtl'"
              (change)="toggleRtl($event.checked)">RTL</mat-slide-toggle>
          </div>
          <div class="settings-row">
            <mat-slide-toggle color="warn" [checked]="boxed"
              (change)="toggleBoxed($event.checked)">Boxed Layout</mat-slide-toggle>
          </div>
          <div class="settings-row" *ngIf="!horizontalActive">
            <mat-slide-toggle [checked]="minisidebar"
              (change)="toggleMinisidebar($event.checked)">Mini Sidebar</mat-slide-toggle>
          </div>
          <mat-divider></mat-divider>
          <!-- <h3 mat-subheader class="text-uppercase font-weight-bold">Colors</h3>
          <mat-list-item>
            <mat-checkbox color="warn" [(ngModel)]="danger" (change)="green = blue = false" class="text-danger">Red
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox color="warn" [(ngModel)]="green" (change)="danger = blue = false" class="text-megna">Teal
              Green</mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox color="warn" [(ngModel)]="blue" (change)="green = danger = false" class="text-info">Blue
            </mat-checkbox>
          </mat-list-item>
          <mat-list-item>
            <mat-checkbox color="warn" [(ngModel)]="dark" (change)="green = blue = danger = false">Dark</mat-checkbox>
          </mat-list-item> -->
        </div>
      </div>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper" [ngClass]="status ? 'minitoggle' : ''">

      <app-breadcrumb></app-breadcrumb>
      <div class="page-content">
        <router-outlet>
          <app-spinner></app-spinner>
        </router-outlet>

      </div>

      <!-- Footer -->
      <!-- <footer class="app-footer">
        <div class="footer-content">
          <p>Powered by DocSecure<br>Product of Sapphirus Systems Pvt Ltd</p>
        </div>
      </footer> -->
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>